const video = document.querySelector('.js-video')
const breakpoint = window.matchMedia('(min-width: 768px)')

if (video && breakpoint.matches) {
  const sources = video.querySelectorAll('source')

  for (let i = 0; i < sources.length; i++) {
    sources[i].src = sources[i].dataset.src
  }

  video.load()
}
